import Vue from 'vue'
import Router from 'vue-router'
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/error/401',
    component: () => import('@/views/error/401'),
    hidden: true,
  },
  {
    path: '/error/404',
    component: () => import('@/views/error/404'),
    hidden: true,
  },
  {
    path: '',
    component: Layout,
    name: '',
    hidden: false,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        meta: { title: '首页', icon: 'dashboard', affix: true },
        component: () => import('@/views/statistics/userview'),
      },
    ],
  },
  {
    path: '',
    component: Layout,
    name: 'Info',
    hidden: true,
    children: [
      {
        path: '/info',
        component: () => import('@/views/info/index'),
      },
    ],
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
]

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: 'history',
  routes: constantRouterMap,
})

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    name: 'statistics',
    meta: {
      title: '数据统计',
      permissions: [
        'admin',
        'userView',
        'userDataList',
        'dividendReport',
        'financialReport',
        'gpTransferRecordReport',
        '1099TaxForm',
        'reconciliation',
      ],
      icon: 'users',
      affix: true,
    },
    children: [
      {
        path: '/statistics/userlist',
        name: 'userlist',
        component: () => import('@/views/statistics/userlist'),
        meta: { title: '用户数据报表', permissions: ['admin', 'userDataList'] },
      },
      {
        path: '/statistics/dividendreport',
        name: 'dividendreport',
        component: () => import('@/views/statistics/dividendreport'),
        meta: {
          title: '分红报表明细',
          permissions: ['admin', 'dividendReport'],
        },
      },
      {
        path: '/statistics/financialreport',
        name: 'financialreport',
        component: () => import('@/views/statistics/financialreport'),
        meta: {
          title: '财务报表',
          permissions: ['admin', 'financialReport'],
        },
      },
      {
        path: '/statistics/GPtransferRecordReport',
        name: 'GPtransferRecordReport',
        component: () => import('@/views/statistics/GPtransferRecordReport'),
        meta: {
          title: 'GP转移记录报表',
          permissions: ['admin', 'gpTransferRecordReport'],
        },
      },
      {
        path: '/statistics/1099taxform',
        name: '1099taxform',
        component: () => import('@/views/statistics/1099taxform'),
        meta: {
          title: '1099税表',
          permissions: ['admin', '1099TaxForm'],
        },
      },
      // {
      //   path: '/statistics/reconciliation',
      //   name: 'reconciliation',
      //   component: () => import('@/views/statistics/reconciliation'),
      //   meta: {
      //     title: '对账管理',
      //     permissions: ['admin', 'reconciliation'],
      //   },
      // },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'USER',
    meta: {
      title: '用户管理',
      permissions: [
        'admin',
        'userList',
        'rechargeLog',
        'userIdLock',
        'blacklist',
      ],
      icon: 'users',
    },
    children: [
      {
        path: '/USER/userlist',
        name: 'userlist',
        component: () => import('@/views/USER/userlist'),
        meta: { title: '用户列表', permissions: ['admin', 'userList'] },
      },
      {
        path: '/USER/rechargehistory',
        name: 'rechargehistory',
        component: () => import('@/views/USER/rechargehistory'),
        meta: { title: '充值记录', permissions: ['admin', 'rechargeLog'] },
      },
      {
        path: '/USER/useridlock',
        name: 'useridlock',
        component: () => import('@/views/USER/useridlock'),
        meta: { title: 'UserID锁定', permissions: ['admin', 'userIdLock'] },
      },
      {
        path: '/USER/useridlockEdit',
        name: 'useridlockEdit',
        hidden: true,
        component: () => import('@/views/USER/useridlockEdit'),
        meta: {
          title: 'UserID锁定编辑',
          permissions: ['admin', 'useridlockEdit'],
        },
      },
      {
        path: '/USER/edituserinfo',
        name: 'edituserinfo',
        hidden: true,
        component: () => import('@/views/USER/edituserinfo'),
        meta: { title: '编辑会员信息', permissions: ['admin', 'userlist'] },
      },
      {
        path: '/USER/createuser',
        name: 'createuser',
        hidden: true,
        component: () => import('@/views/USER/createuser'),
        meta: { title: '创建用户', permissions: ['admin', 'userlist'] },
      },
      {
        path: '/USER/blacklist',
        name: 'blacklist',
        component: () => import('@/views/USER/blacklist'),
        meta: { title: '用户黑名单', permissions: ['admin', 'blacklist'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'member',
    meta: {
      title: '会员管理',
      permissions: ['admin', 'vipProduct', 'vipBuyLogs', 'teamTree'],
      icon: 'users',
    },
    children: [
      {
        path: '/member/membershipplan',
        name: 'membershipplan',
        component: () => import('@/views/member/membershipplan'),
        meta: { title: '会员套餐', permissions: ['admin', 'vipProduct'] },
      },
      {
        path: '/member/memberlist',
        name: 'memberlist',
        component: () => import('@/views/member/memberlist'),
        meta: { title: '会员列表', permissions: ['admin', 'vip'] },
      },
      {
        path: '/member/PurchaseHistory',
        name: 'PurchaseHistory',
        component: () => import('@/views/member/PurchaseHistory'),
        meta: { title: '购买记录', permissions: ['admin', 'vipBuyLogs'] },
      },
      {
        path: '/member/teamtree',
        name: 'teamtree',
        component: () => import('@/views/member/teamtree'),
        meta: { title: '团队结构', permissions: ['admin', 'teamTree'] },
      },
      {
        path: '/member/setshipplan',
        name: 'setshipplan',
        hidden: true,
        component: () => import('@/views/member/setshipplan'),
        meta: { title: '修改套餐', permissions: ['admin', 'vipProduct'] },
      },
      {
        path: '/member/editmemberinfo',
        name: 'editmemberinfo',
        hidden: true,
        component: () => import('@/views/member/editmemberinfo'),
        meta: { title: '编辑会员信息', permissions: ['admin', 'vip'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'order',
    meta: {
      title: '订单管理',
      permissions: ['admin', 'order'],
      icon: 'users',
    },
    children: [
      {
        path: '/order/orderlist',
        name: 'orderlist',
        component: () => import('@/views/order/orderlist'),
        meta: { title: '订单列表', permissions: ['admin', 'order'] },
      },
      {
        path: '/order/orderdetila',
        name: 'orderdetila',
        hidden: true,
        component: () => import('@/views/order/orderdetila'),
        meta: { title: '订单详情', permissions: ['admin', 'order'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'goods',
    meta: {
      title: '商品管理',
      permissions: ['admin', 'product'],
      icon: 'users',
    },
    children: [
      {
        path: '/goods/goodslist',
        name: 'goodslist',
        component: () => import('@/views/goods/goodslist'),
        meta: { title: '商品列表', permissions: ['admin', 'product'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'transaction',
    meta: {
      title: '交易管理',
      permissions: ['admin', 'userCashOut'],
      icon: 'users',
    },
    children: [
      {
        path: '/transaction/transactionlist',
        name: 'transactionlist',
        component: () => import('@/views/transaction/transactionlist'),
        meta: { title: '提现管理', permissions: ['admin', 'userCashOut'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'bonus',
    meta: {
      title: '奖金发放管理',
      permissions: [
        'admin',
        'bonusList',
        'pointList',
        'bonusConfig',
        'retailReward',
        'referralReward',
        'expandReward',
        'welfareReward',
        'globalBonus',
        'globalBonusDistribution',
      ],
      icon: 'users',
    },
    children: [
      {
        path: '/bonus/bonuslist',
        name: 'bonuslist',
        component: () => import('@/views/bonus/bonuslist'),
        meta: { title: '奖励金列表', permissions: ['admin', 'bonusList'] },
      },
      {
        path: '/bonus/integrallist',
        name: 'integrallist',
        component: () => import('@/views/bonus/integrallist'),
        meta: { title: '积分列表', permissions: ['admin', 'pointList'] },
      },
      // {
      //   path: '/bonus/setbonus',
      //   name: 'setbonus',
      //   component: () => import('@/views/bonus/setbonus'),
      //   meta: { title: '奖励金设置', permissions: ['admin', 'bonusConfig'] },
      // },
      // {
      //   path: '/bonus/setdistribution',
      //   name: 'setdistribution',
      //   component: () => import('@/views/bonus/setdistribution'),
      //   meta: { title: '建设奖设置', permissions: ['admin'] },
      // },
      {
        path: '/bonus/retailRewards',
        name: 'retailRewards',
        component: () => import('@/views/bonus/retailRewards'),
        meta: { title: '零售奖励配置', permissions: ['admin', 'retailReward'] },
      },
      {
        path: '/bonus/referralRewards',
        name: 'referralRewards',
        component: () => import('@/views/bonus/referralRewards'),
        meta: {
          title: '分享奖&建设奖配置',
          permissions: ['admin', 'referralReward'],
        },
      },
      {
        path: '/bonus/expandRewards',
        name: 'expandRewards',
        component: () => import('@/views/bonus/expandRewards'),
        meta: { title: '成长奖励配置', permissions: ['admin', 'expandReward'] },
      },
      {
        path: '/bonus/welfareRewards',
        name: 'welfareRewards',
        component: () => import('@/views/bonus/welfareRewards'),
        meta: {
          title: '丰盛奖励配置',
          permissions: ['admin', 'welfareReward'],
        },
      },
      {
        path: '/bonus/globalBonusPool',
        name: 'globalBonusPool',
        component: () => import('@/views/bonus/globalBonusPool'),
        meta: { title: '全球分红', permissions: ['admin', 'globalBonus'] },
      },
      {
        path: '/bonus/globaldividenddistribution',
        name: 'globaldividenddistribution',
        component: () => import('@/views/bonus/globaldividenddistribution'),
        meta: {
          title: '创始人分红发放',
          permissions: ['admin', 'globalBonusDistribution'],
        },
      },
      // {
      //   path: '/bonus/vipdividenddistribution',
      //   name: 'vipdividenddistribution',
      //   component: () => import('@/views/bonus/vipdividenddistribution'),
      //   meta: {
      //     title: 'VIP 分红发放',
      //     permissions: ['admin', 'globalBonusDistribution'],
      //   },
      // },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'bulletin',
    meta: {
      title: '公告管理',
      permissions: ['admin', 'systemNotice'],
      icon: 'users',
    },
    children: [
      {
        path: '/bulletin/System',
        name: 'System',
        component: () => import('@/views/bulletin/System'),
        meta: { title: '系统公告', permissions: ['admin', 'systemNotice'] },
      },
      {
        path: '/bulletin/edit',
        name: 'edit',
        hidden: true,
        component: () => import('@/views/bulletin/edit'),
        meta: { title: '系统公告', permissions: ['admin', 'systemNotice'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'operation',
    meta: {
      title: '运营管理',
      permissions: [
        'admin',
        'rpDiscountCodeList',
        'hpDiscountCodeList',
        'discountCodeConfig',
        'giftCodeList',
        'docList',
        'vipUpgradeTemplate',
        'CustomRpVoucherList',
      ],
      icon: 'users',
    },
    children: [
      {
        path: '/operation/doclist',
        name: 'doclist',
        component: () => import('@/views/operation/doclist'),
        meta: { title: '文档管理', permissions: ['admin', 'docList'] },
      },
      {
        path: '/operation/doclistedit',
        name: 'doclistedit',
        hidden: true,
        component: () => import('@/views/operation/doclistedit'),
        meta: { title: '文档编辑', permissions: ['admin', 'doclistedit'] },
      },
      {
        path: '/operation/RPlist',
        name: 'RPlist',
        component: () => import('@/views/operation/RPlist'),
        meta: {
          title: 'RP优惠码类型列表',
          permissions: ['admin', 'rpDiscountCodeList'],
        },
      },
      {
        path: '/operation/exchangeDetail',
        name: 'ExchangeDetail',
        component: () => import('@/views/operation/exchangeDetail'),
        meta: {
          title: '兑换详情',
          permissions: ['admin', 'rpDiscountCodeList'],
        },
        hidden: true,
      },
      {
        path: '/operation/edit',
        name: 'edit',
        hidden: true,
        component: () => import('@/views/operation/edit'),
        meta: {
          title: '兑换码类型编辑',
          permissions: ['admin', 'rpDiscountCodeList'],
        },
      },
      {
        path: '/operation/HPlist',
        name: 'HPlist',
        component: () => import('@/views/operation/HPlist'),
        meta: {
          title: 'GP优惠码兑换列表',
          permissions: ['admin', 'hpDiscountCodeList'],
        },
      },
      {
        path: '/operation/GiftCodeList',
        name: 'GiftCodeList',
        component: () => import('@/views/operation/GiftCodeList'),
        meta: {
          title: 'GP礼品卡兑换列表',
          permissions: ['admin', 'giftCodeList'],
        },
      },
      {
        path: '/operation/customRpVoucherList',
        name: 'CustomRpVoucherList',
        component: () => import('@/views/operation/customRpVoucherList'),
        meta: {
          title: '自定义RP兑换列表',
          permissions: ['admin', 'customRpVoucherList'],
        },
      },
      {
        path: '/operation/codeset',
        name: 'codeset',
        component: () => import('@/views/operation/codeset'),
        meta: {
          title: '优惠码配置',
          permissions: ['admin', 'discountCodeConfig'],
        },
      },
      {
        path: '/operation/vipupgradetemplate',
        name: 'vipupgradetemplate',
        component: () => import('@/views/operation/vipupgradetemplate'),
        meta: {
          title: 'VIP升级消息模板列表',
          permissions: ['admin', 'vipUpgradeTemplate'],
        },
      },
      {
        path: '/operation/vipupgradetemplateedit',
        name: 'vipupgradetemplateedit',
        hidden: true,
        component: () => import('@/views/operation/vipupgradetemplateedit'),
        meta: {
          title: 'VIP升级消息模板编辑',
          permissions: ['admin', 'vipUpgradeTemplate'],
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Admin',
    meta: {
      title: '管理员设置',
      permissions: ['admin', 'adminList'],
      icon: 'system',
    },
    children: [
      {
        path: '/admin/list',
        name: 'Admin',
        component: () => import('@/views/admin/index'),
        meta: { title: '管理员列表', permissions: ['admin', 'adminList'] },
      },
    ],
  },
  { path: '*', redirect: '/error/404', hidden: true },
]
